// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"HomeCollectionsRow_sectionHeading__MVgFV","icon":"HomeCollectionsRow_icon__pv_9b","collectionsSlide":"HomeCollectionsRow_collectionsSlide__u5SwW"};